import Layout from "../../layout";
import PageHeader from "../../components/PageHeader";

export default function PreferenciasPage() {
  return (
    <Layout>
      <article className="mx-auto max-w-3xl">
        <PageHeader
          title="Sobre a ferramenta"
          description="Créditos, método e direitos autorais do QualificaURB."
        />

        <div className="space-y-5 rounded-2xl border border-border bg-white p-6 leading-relaxed text-gray shadow-sm sm:p-8">
          <p>
            Organizada em 4 categorias e, a partir disso, subdividida em 11
            atributos e 24 indicadores, a ferramenta aborda assuntos pertinentes
            e necessários para a vitalidade das praças. Temas como{" "}
            <strong>Proteção e Segurança</strong>,{" "}
            <strong>Conforto e Imagem</strong>,{" "}
            <strong>Acessos e Conexões</strong> e{" "}
            <strong>Sociabilidade, usos e atividades</strong> foram detalhados de
            forma a tornar possível o processo de avaliação.
          </p>
          <p>
            Para obter resultados objetivos e mensuráveis, todos os indicadores
            são pontuados no intervalo de 0 (insuficiente) a 3 (ótimo),
            permitindo, após o preenchimento, a classificação final da praça
            analisada: Insuficiente (0–0,75), Regular (0,76–1,5), Bom (1,51–2,25)
            e Ótimo (2,26–3).
          </p>
          <p>
            Este trabalho foi desenvolvido no âmbito do Grupo de Pesquisa CNPq
            “Paisagem Urbana e Inclusão”, da Universidade Federal do Espírito
            Santo e da Universidade Vila Velha, sob a coordenação e autoria das
            professoras doutoras Karla Conde Moreira (UFES), Larissa Leticia
            Andara Ramos (UVV) e Luciana Aparecida Netto de Jesus (UFES). Teve
            como referência o Índice de Caminhabilidade — iCam (BRASIL ITDP,
            2019) e uma rigorosa revisão bibliográfica que permitiram as
            adequações necessárias para a avaliação de praças.
          </p>
          <p>
            Todo o conteúdo deste documento é de propriedade intelectual das
            autoras. O uso indevido do material (divulgação, reprodução ou cópia
            integral ou parcial), sem prévia autorização, viola o art. 46,
            Capítulo IV, da Lei nº 9.610/98, que trata dos direitos autorais.
            Qualquer pessoa que ignorar essa regra estará sujeita à indenização
            que pode ser exigida pelas autoras e pelas IES envolvidas, em ação
            judicial própria.
          </p>
        </div>
      </article>
    </Layout>
  );
}
